import React from 'react';

/**
 * Reusable territory strip (horizontal tag filter).
 */
const TerritoryStrip = ({ items = [], className = '' }) => {
  const [active, setActive] = React.useState(0);

  return (
    <div className={`territory-strip ${className}`}>
      {items.map((item, i) => (
        <span
          className={`territory-strip__item${i === active ? ' territory-strip__item--active' : ''}`}
          key={item}
          onClick={() => setActive(i)}
        >
          {item}
        </span>
      ))}
    </div>
  );
};

export default TerritoryStrip;
